import { Tabs, TabsProps } from '@mui/material';
import { ReactElement } from 'react';

export function ModuleTabs(props: TabsProps): ReactElement {
  return (
    <div className="bg-grey-50 flex min-h-20 items-end">
      <Tabs {...props} />
    </div>
  );
}
